
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/terms",
      function () {
        return require("private-next-pages/[lang]/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/terms"])
      });
    }
  